module.exports = __webpack_public_path__ + "img/slika37.7085e2f2.jpg";